import { DiagnosticsService } from "../../../services/diagnostics";

const DTCS = DiagnosticsService.getDtcs();

export default function DiagnosticsDtcPage() {
  const dtcs = DTCS.map((d) => ({
    id: d.id,
    node: d.node,
    code: `DTC ${d.id}`,
    description: d.description,
    timestamp: d.timestamp,
    severity: d.severity === "critical" ? "High" : "Medium",
    tone: d.severity === "critical" ? "red" : "amber",
    icon: d.severity === "critical" ? "❗" : "⚠️",
  }));

  const cardTone = (tone) => {
    if (tone === "red") return "border-red-500/40 bg-red-900/20";
    if (tone === "amber") return "border-amber-500/40 bg-amber-900/20";
    return "border-brand-navy bg-brand-purple";
  };

  const pillClass = (tone) =>
    tone === "red" ? "bg-red-500 text-white" : "bg-amber-400 text-slate-900";

  return (
    <div className="space-y-4">
      {dtcs.map((item) => (
        <div
          key={item.id}
          className={`rounded-2xl border ${cardTone(item.tone)} px-4 py-3 flex flex-col gap-2`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-full text-lg ${
                  item.tone === "red"
                    ? "bg-red-900/40 text-red-300 border border-red-500/40"
                    : "bg-amber-900/30 text-amber-300 border border-amber-500/40"
                }`}
              >
                {item.icon}
              </span>
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-brand-light">{item.node}</span>
                <span className="text-xs font-semibold text-brand-light">{item.code}</span>
                <span className="text-xs text-brand-light/70">{item.description}</span>
              </div>
            </div>
            <span className={`text-[11px] font-semibold px-2 py-1 rounded-full ${pillClass(item.tone)}`}>
              {item.severity}
            </span>
          </div>
          <div className="flex items-center justify-between text-[11px] text-brand-light/50">
            <span>Last seen</span>
            <span>{item.timestamp}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
